module.exports = __webpack_public_path__ + "img/zx1.ea8ee11d.png";